<template>
	<div class="flex">
		<div class="bg flex-grow">
			<img src="@/assets/image/login_bg_text.png" alt="">
		</div>
		<div class="main flex-column flex-between-center">
			<div class="head flex-between-center">
				<img src="@/assets/image/login_logo.png" alt="">
			</div>
			<div class="login">
				<h1 class="title">欢迎登录 — 蜂鸟工单系统</h1>
				<c-tab-list ref="tabList" class="tabs" :tabs="typeList" @change="data => type = data.value"></c-tab-list>

				<c-form v-show="type == 1" ref="phoneLogin" class="form">
					<c-input v-model="phone" class="item" type="text" name="phone" placeholder="请输入手机号" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-phone tf-fw"></i>
						</template>
					</c-input>
					<c-input class="item" type="text" name="verify_code" placeholder="短信验证码" :clear="false" maxlength="4" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-smscode tf-fw"></i>
						</template>
						<template #append>
							<a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
						</template>
					</c-input>
				</c-form>

				<c-form v-show="type == 2" ref="userLogin" class="form">
					<c-input class="item" type="text" name="user_name" placeholder="请输入用户名" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-username tf-fw"></i>
						</template>
					</c-input>
					<c-input class="item" type="password" name="user_pwd" placeholder="请输入密码" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-password tf-fw"></i>
						</template>
					</c-input>
				</c-form>
				<c-button class="button" size="form" color="main" @click="login">登录</c-button>
			</div>
			<p class="copyright">版权所有©2023-{{new Date().getFullYear()}} 杭州云创数智科技有限公司</p>
		</div>

		<c-dialog ref="factoryList" width="600" :title="false" :close-button="false" :button="false">
			<dl class="factory-list">
				<dt>请选择工厂</dt>
				<dd>
					<ul>
						<li v-for="(item, i) in factoryList" :key="i" class="flex-center" @click="factoryHandle(item)">
							<i class="icon tf-company"></i>
							<p class="flex-grow ellipsis">{{item.saas_name}}</p>
						</li>
					</ul>
				</dd>
			</dl>
		</c-dialog>
	</div>
</template>

<script>
	import {cryptoJs} from '@deanwu/vue-component-library'
	
	export default {
		props: {
			redirect: {
				type: String,
				default: '/'
			}
		},

		data() {
			return {
				typeList: [{
					name: '手机号登录',
					value: 1
				}, {
					name: '账号登录',
					value: 2
				}],
				type: 1,
				phone: '',
				countdown: false,
				
				factoryList: []
			}
		},

		computed: {
			countdownText() {
				return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
			}
		},

		methods: {
			getSmscode() {
				if (this.countdown) return;
				if (!this.phone) {
					this.$message({
						message: '请输入手机号'
					});
					return;
				}
				this.request({
					url: '/login/verify/code',
					data: {
						client: 0,
						phone: this.phone
					},
					loading: true,
					success: () => {
						this.$message({
							message: '验证码已发送'
						});
						!function loop(s) {
							this.countdown = s;
							if (s == 0) return;
							this._timer = setTimeout(() => {
								loop.call(this, --s);
							}, 1000);
						}.call(this, 60);
					}
				});
			},

			login() {
				if (this.type == 1) {
					this.$refs.phoneLogin.submit({
						url: '/login/verify/code/check',
						breakWhenFail: true,
						rule: {
							phone: '请输入手机号',
							verify_code: '请输入短信验证码'
						},
						dataFormatter: data => {
							data.client = 0;
							return data;
						},
						success: (data, res) => {
							if (!res.user_info.saas_id) {
								this._session = res.user_info.session;
								this.getFactory();
							} else {
								this.$store.dispatch('setLoginInfo', res);
								this.redirectTo(this.redirect);
							}
						},
						fail: () => {
							clearTimeout(this._timer);
							this.countdown = 0;
						}
					});
				} else {
					this.$refs.userLogin.submit({
						url: '/sys_user/login',
						breakWhenFail: true,
						rule: {
							user_name: '请输入用户名',
							user_pwd: '请输入密码'
						},
						dataFormatter: data => {
							data.saas_name = '607330';
							data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
							return data;
						},
						success: (data, res) => {
							this.$store.dispatch('setLoginInfo', res);
							this.redirectTo(this.redirect);
						}
					});
				}
			},

			getFactory() {
				this.request({
					url: '/sys_user/saas/list',
					data: {
						session: this._session
					},
					loading: true,
					success: data => {
						this.factoryList = data;
						this.$refs.factoryList.open();
					}
				});
			},
			
			factoryHandle(data) {
				this.request({
					url: '/sys_user/mobile/login',
					data: {
						session: this._session,
						saas_id: data.saas_id
					},
					loading: true,
					success: data => {
						this.$store.dispatch('setLoginInfo', data);
						this.redirectTo(this.redirect);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.bg {
		position: relative;
		height: 100vh;
		overflow: hidden;
		background-color: #32373E;
		background-image: url('~@/assets/image/login_bg.jpg');
		background-size: cover;

		img {
			position: absolute;
			left: 70px;
			bottom: 200px;
			width: 600px;
			max-width: none;
			height: 145px;
		}
	}

	.main {
		width: 700px;
		height: 100vh;
		background: #F8FFFD;
		
		.head {
			box-sizing: border-box;
			width: 100%;
			height: 90px;
			border-bottom: 1px solid #eee;
			padding: 0 20px 0 30px;
			
			img {
				height: 45px;
			}
		}
		
		.login {
			box-sizing: border-box;
			width: 360px;
			height: 340px;
			margin-bottom: 80px;
			
			.title {
				margin-bottom: 38px;
				font-size: 24px;
				font-weight: normal;
				text-align: center;
			}

			.tabs {
				margin-bottom: 30px;

				>>> ul {
					border-bottom-color: #E5E5E5;

					li.z-crt {
						font-size: 18px;
					}
				}
			}
			
			.form {
				padding: 0;
				
				.item {
					height: 40px;
					margin-bottom: 12px;
					
					&-icon {
						margin: 0 10px 0 12px;
						font-size: 14px;
						color: #bbb;

						^[-1]:focus-within ^[-2..-1] {
							color: #000;
						}
					}

					.smscode {
						display: block;
						margin-top: 9px;
						margin-right: 8px;
						line-height: 20px;
						font-size: 12px;
						color: var(--color-main);

						&.z-dis {
							color: #999;
						}
					}
				}
			}
			
			.button {
				width: 100%;
				height: 46px !important;
				border-radius: 2px;
				margin: 8px 0 26px;
				font-size: 18px;
			}
			
			.handle {
				a {
					font-size: 13px;
					color: #0060EF;
				}
			}
		}
		
		.copyright {
			width: 100%;
			line-height: 60px;
			font-size: 12px;
			text-align: center;
			color: #999;
		}
	}

	.factory-list {
		border-radius: 10px;
		padding: 0 30px 40px;
		background: #FFFFFF;

		dt {
			line-height: 100px;
			font-size: 24px;
			font-weight: bold;
			text-align: center;
		}

		dd {
			li {
				height: 60px;
				border-radius: 4px;
				padding: 0 22px;
				margin-bottom: 13px;
				color: #fff;
				background: #32373E;
				cursor: pointer;

				&:hover {
					background: var(--color-main);
				}

				.icon {
					margin-right: 16px;
					font-size: 20px;
				}
			}
		}
	}
</style>
